import { ColumnType } from "antd/es/table";
import { applyOrderStd, CtrlColumns } from "../TableStore";
import { visibleFixedLeft } from "../ColumnPoor";

export const makeAntColumns = <T extends {}>(
  store: CtrlColumns,
): ColumnType<T>[] => {
  const fixedCount = visibleFixedLeft(
    applyOrderStd(store, store.columns),
    store,
  );
  return store.finalColumns.map((col, colIndex) => ({
    ...col,
    fixed: colIndex < fixedCount ? "left" : undefined,
  }));
};
